import { ReactNode } from "react";
import AllCentered from "./AllCentered";

const FloatingOverlay = (props: {children: ReactNode}) =>
    <AllCentered className="FloatingOverlay">
        {props.children}
    </AllCentered>

export default FloatingOverlay;